import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepSix(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

        useEffect(() => {
            if (props.datas.consequences && Object.keys(props.datas.consequences).length >= 1) {
                buttons[1].disabled = false;
            } else {
                buttons[1].disabled = true;
            }
            setButtons([...buttons]);
        }, [props.datas]);

    function handleChange(e){
        let datas = Object.assign({}, props.datas);
        if(!datas.consequences){
            datas.consequences = [];
        }
        let filtered = datas.consequences.filter( data => data != e.target.value);
        if(e.target.checked){
            filtered.push(e.target.value);
        }
        datas.consequences = filtered;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, dans l’ensemble, quels seront pour vous les conséquences de la nouvelle règlementation sur le changement d’usage : (Plusieurs réponses possibles)
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        name="radio-buttons-group">
                        <FormControlLabel value="Aucune conséquence" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Aucune conséquence"/>
                        <FormControlLabel value="Perte partielle de chiffres d’affaires" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Perte partielle de chiffres d’affaires" />
                        <FormControlLabel value="Perte majeure de chiffres d’affaires" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Perte majeure de chiffres d’affaires" />
                        <FormControlLabel value="Licenciement ou Arrêt des projets d’embauche" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Licenciement ou Arrêt des projets d’embauche" />
                        <FormControlLabel value="Baisse du traffic dans le quartier" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Baisse du traffic dans le quartier" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}